import { useTranslation } from 'react-i18next';
import type { IApiErrorPlain } from '@platform/core/types';
import { Icon } from './Icon';
import type { IErrorBannerProps } from './IErrorBannerProps';

/** Повідомлення про помилку API (UIUX/foundations/states: колір --danger) з переліком помилок валідації за полями. */
export function ErrorBanner({ error }: IErrorBannerProps) {
  const { t } = useTranslation();
  if (!error) return null;
  const e = error as Partial<IApiErrorPlain>;
  const fields = Object.entries(e.errors ?? {});
  return (
    <div className="error-banner" role="alert">
      <Icon name="circle-alert" size={16} className="error-banner__icon" />
      <div className="error-banner__body">
        <strong>{t('app.error')}:</strong> {e.message ?? String(error)}
        {fields.length > 0 && (
          <ul className="error-banner__list">
            {fields.map(([k, msgs]) => <li key={k}><code className="mono">{k}</code> — {msgs.join('; ')}</li>)}
          </ul>
        )}
      </div>
    </div>
  );
}
